import React, { useEffect } from "react"
// import ReactPlayer from "react-player"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { home } from "../../routes"
import "./Landing.css"
import { useStore } from "../../components/ApartmentFinder/State/Store"
import ReactPlayer from "react-player"
import styled from "styled-components"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

function Landing() {
  const loaded = useStore(state => state.loaded)

  return (
    <>
      <Link to={home.path}>
        <VidWrapper>
          <ReactPlayer
            height="100%"
            width="100%"
            url={`${process.env.PUBLIC_URL}/assets/videos/splash.mp4`}
            playsinline={true}
            loop={true}
            playing={true}
            controls={false}
            muted={true}
          ></ReactPlayer>
        </VidWrapper>
      </Link>
    </>
  )
}

const VidWrapper = styled.div`
  overflow: hidden;
  background: "#fff";
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  background-color: #381c50;

  display: flex;
  justify-content: center;
  align-items: center;

  & video {
    object-position: center;
    object-fit: contain;
  }
`

export default Landing
